module.exports = __webpack_public_path__ + "files/SPIADI2024 - Etude multicentrique CleanHandPROX.33412aafd632327607e66ebf64379505.pdf";